enum ThumbnailStatus
{
	Loading = 1,
	Loaded = 2,
	Failed = 3
}

export default ThumbnailStatus;